import { render } from "./ResultsListnew.vue?vue&type=template&id=814177f4&scoped=true"
import script from "./ResultsListnew.vue?vue&type=script&lang=js"
export * from "./ResultsListnew.vue?vue&type=script&lang=js"

import "./ResultsListnew.vue?vue&type=style&index=0&id=814177f4&lang=scss"
import "./ResultsListnew.vue?vue&type=style&index=1&id=814177f4&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src2874961510/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-814177f4"]])

export default __exports__